import { Injectable } from "@angular/core"
import { environment } from "../../../../environments/environment"
import { HttpClient } from "@angular/common/http"
import { ITableResponse } from "../models/contracts/table"
import {
  Occurrency,
  OccurrenceGroupedDetail,
} from "../models/occurrency/occurrency"
import { map } from "rxjs/operators"
import { AppService } from "src/app/core/services/app.service"
import { BehaviorSubject, Observable } from "rxjs"
import OccurrencyOperationType from "../models/occurrency/ocurrency-type"
import { IPaginateResponse } from "../models/interfaces/i-paginate-response"
import { toHttpParams } from "src/app/core/helpers/http-params-extensions"

@Injectable({
  providedIn: "root",
})
export class OccurrencyService {
  private occurrencyOperationSubject = new BehaviorSubject<
    OccurrencyOperationType[]
  >([])
  occurrencyOperationArray$ = this.occurrencyOperationSubject.asObservable()

  private get_occurrency_url: string
  private put_occurrency_url: string
  private get_occurrency_id_url: string
  private download_occurrency_id_url: string
  private get_occurrency_operations: string
  private get_grouped_details: string
  private get_details_paginate: string
  private put_pre_enrollment: string
  private get_occurrency_status: string

  private buildUrls(occurrencyUrl: string) {
    this.get_occurrency_url =
      occurrencyUrl +
      environment.endpointOccurrency.routes.get_occurrency_paginate
    this.put_occurrency_url =
      occurrencyUrl + environment.endpointOccurrency.routes.put_occurrency
    this.get_occurrency_id_url =
      occurrencyUrl + environment.endpointOccurrency.routes.get_occurrency_id
    this.download_occurrency_id_url =
      occurrencyUrl +
      environment.endpointOccurrency.routes.download_occurrency_id
    this.get_occurrency_operations =
      occurrencyUrl +
      environment.endpointOccurrency.routes.get_occurrency_operation
    this.get_grouped_details =
      occurrencyUrl + environment.endpointOccurrency.routes.get_grouped_details
    this.get_details_paginate =
      occurrencyUrl + environment.endpointOccurrency.routes.get_details_paginate
  }

  constructor(private httpClient: HttpClient, private appService: AppService) {
    this.buildUrls(environment.endpointOccurrency.url)
    this.put_pre_enrollment =
      environment.endpointPreEnrollment.url +
      environment.endpointPreEnrollment.routes.put_aprove_pre_enrollment

    this.get_occurrency_status =
      environment.endpointPreEnrollment.url +
      environment.endpointOccurrenceBackoffice.routes.get_status
  }

  getPaginate(occurrency: any) {
    const params = toHttpParams(occurrency)

    return this.httpClient.get<ITableResponse<any>>(this.get_occurrency_url, {
      params,
    })
  }
  putStatus(items: any, countryType: number) {
    return this.httpClient.put(
      `${this.put_occurrency_url
        .replace("{action}", items.name)
        .replace("{occurrencyId}", items.id)}?countryType=${countryType}`,
      items
    )
  }

  getOccurrency(id: string) {
    return this.httpClient
      .get<Occurrency>(this.get_occurrency_id_url.replace("{occurrencyId}", id))
      .pipe(
        map((occurrency) => ({
          ...occurrency,
          startDate: occurrency.startDate
            ? new Date(occurrency.startDate)
            : null,
          finishedDate: occurrency.finishedDate
            ? new Date(occurrency.finishedDate)
            : null,
        }))
      )
  }

  downloadOccurrency(id: string) {
    return this.httpClient.get(
      this.download_occurrency_id_url.replace("{occurrencyId}", id)
    )
  }

  GetOcurrencyOperations() {
    return this.httpClient.get(this.get_occurrency_operations)
  }

  getOccurrenceStatus() {
    return this.httpClient.get(this.get_occurrency_status)
  }
  /* PostOffice in Batch */
  getGroupedDetails(
    occurrenceId: string
  ): Observable<OccurrenceGroupedDetail[]> {
    return this.httpClient.get<OccurrenceGroupedDetail[]>(
      this.get_grouped_details.replace("{occurrenceId}", occurrenceId)
    )
  }

  getDetailsPaginate(
    occurrenceId: string,
    filter: any
  ): Observable<IPaginateResponse> {
    const params = toHttpParams(filter)
    return this.httpClient.get<IPaginateResponse>(
      this.get_details_paginate.replace("{occurrenceId}", occurrenceId),
      { params }
    )
  }

  putStatusPreEnrollment(items: any, countryType: number) {
    return this.httpClient.put(
      `${this.put_pre_enrollment
        .replace("{action}", items.name)
        .replace("{occurrenceId}", items.id)}?countryType=${countryType}`,
      items
    )
  }

  loadOccurrencyOperation() {
    this.GetOcurrencyOperations().subscribe(
      (response: OccurrencyOperationType[]) => {
        this.occurrencyOperationSubject.next(response)
      },
      (error) => {
        console.error("Error loading occurrency operations", error)
      }
    )
  }
}
